
// import { useMemo, useState, useRef, useEffect, useCallback } from "react";
// import { tocMap } from "../../data/tocMap";
// import { MdSupportAgent } from "react-icons/md";
// import { createPortal } from "react-dom";

// export default function Toc({ activeSection, focusMode, onToggleFocusMode }) {
//   const [activeId, setActiveId] = useState(null);
//   const tocScrollRef = useRef(null);
//   const [showContact, setShowContact] = useState(false);
//   const [copied, setCopied] = useState(false);
//   const [readPercent, setReadPercent] = useState(0);

//   const items = useMemo(() => {
//     return tocMap?.[activeSection] || [];
//   }, [activeSection]);

//   const getScrollRoot = () => document.querySelector("main");

//   const updateActiveId = useCallback(() => {
//     if (!items.length) return;

//     const scrollRoot = getScrollRoot();
//     if (!scrollRoot) return;

//     const rootRect = scrollRoot.getBoundingClientRect();
//     const activationY = rootRect.top + 120;

//     const atBottom =
//       scrollRoot.scrollTop + scrollRoot.clientHeight >=
//       scrollRoot.scrollHeight - 2;

//     const positions = items
//       .map((item) => {
//         const el = document.getElementById(item.id);
//         if (!el) return null;

//         const rect = el.getBoundingClientRect();
//         return {
//           id: item.id,
//           top: rect.top,
//           bottom: rect.bottom,
//         };
//       })
//       .filter(Boolean)
//       .sort((a, b) => a.top - b.top);

//     if (!positions.length) return;

//     if (atBottom) {
//       setActiveId(positions[positions.length - 1].id);
//       return;
//     }

//     let currentId = positions[0].id;

//     for (const pos of positions) {
//       if (pos.top <= activationY) {
//         currentId = pos.id;
//       } else {
//         break;
//       }
//     }

//     setActiveId(currentId);
//   }, [items]);

//   // Reading progress (% scrolled through the main content area)
//   const updateReadPercent = useCallback(() => {
//     const scrollRoot = getScrollRoot();
//     if (!scrollRoot) return;

//     const scrollable = scrollRoot.scrollHeight - scrollRoot.clientHeight;
//     const pct =
//       scrollable <= 0
//         ? 100
//         : Math.min(
//             100,
//             Math.max(0, Math.round((scrollRoot.scrollTop / scrollable) * 100))
//           );

//     setReadPercent(pct);
//   }, []);

//   useEffect(() => {
//     if (!items.length) return;

//     const scrollRoot = getScrollRoot();
//     if (!scrollRoot) return;

//     let rafId = 0;

//     const onScroll = () => {
//       cancelAnimationFrame(rafId);
//       rafId = requestAnimationFrame(() => {
//         updateActiveId();
//         updateReadPercent();
//       });
//     };

//     scrollRoot.addEventListener("scroll", onScroll, { passive: true });
//     window.addEventListener("resize", onScroll);

//     requestAnimationFrame(() => {
//       updateActiveId();
//       updateReadPercent();
//     });

//     return () => {
//       cancelAnimationFrame(rafId);
//       scrollRoot.removeEventListener("scroll", onScroll);
//       window.removeEventListener("resize", onScroll);
//     };
//   }, [items, activeSection, updateActiveId, updateReadPercent]);

//   useEffect(() => {
//     requestAnimationFrame(() => {
//       if (tocScrollRef.current) {
//         tocScrollRef.current.scrollTop = 0;
//       }
//     });

//     if (items.length) {
//       setActiveId(items[0].id);
//     } else {
//       setActiveId(null);
//     }
//   }, [activeSection, items]);

//   const scrollToId = (id) => {
//     const el = document.getElementById(id);
//     if (el) {
//       el.scrollIntoView({
//         behavior: "smooth",
//         block: "start",
//       });
//       setActiveId(id);
//     }
//   };

//   if (!items.length) return null;

//   return (
//     <aside
//       className={`
//     hidden xl:block
//     fixed right-0
//     top-16
//     bottom-0
//     w-72
//     ${focusMode ? "" : "border-l border-gray-200 dark:border-gray-800"}
//     bg-white dark:bg-[#0f0f0f]
//     text-sm text-gray-500
//     z-40
//   `} 
//     >
//       <div className="flex flex-col h-full px-6 py-5">
//         <div
//           ref={tocScrollRef}
//           className="flex-1 overflow-y-auto flex flex-col gap-2 pb-38"
//         >
//           <div>
//             <div className="flex items-center justify-between mb-2">
//               <h3 className="text-xs font-bold text-text-muted uppercase tracking-wider">
//                 On This Page
//               </h3>

//               <label className="flex items-center gap-1.5 cursor-pointer select-none">
//                 <span className="text-[11px] text-text-muted">Focus mode</span>
//                 <span
//                   role="switch"
//                   aria-checked={focusMode}
//                   onClick={() => onToggleFocusMode?.()}
//                   className={`relative inline-flex h-4 w-8 items-center rounded-full transition-colors
//                     ${focusMode ? "bg-blue-600" : "bg-gray-300 dark:bg-gray-600"}`}
//                 >
//                   <span
//                     className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition-transform
//                       ${focusMode ? "translate-x-4" : "translate-x-0.5"}`}
//                   />
//                 </span>
//               </label>
//             </div>

//             <div className="flex justify-end mb-1">
//               <span className="text-[10px] text-text-muted">
//                 {readPercent}% read
//               </span>
//             </div>

//             <div className="w-full h-1 bg-gray-200 dark:bg-gray-700 rounded-full mb-4 overflow-hidden">
//               <div
//                 className="h-full bg-blue-600 rounded-full transition-all duration-150"
//                 style={{ width: `${readPercent}%` }}
//               />
//             </div>

//             <nav className="hide-scrollbar flex flex-col border-l border-gray-200 dark:border-gray-700">
//               {items.map((item) => {
//                 const isActive = activeId === item.id;

//                 return (
//                   <button
//                     key={item.id}
//                     onClick={() => scrollToId(item.id)}
//                     className={`block text-left pl-4 py-1 text-sm -ml-[1px] border-l-2 transition-all
//                       ${
//                         isActive
//                           ? "text-blue-600 dark:text-blue-400 border-blue-500 font-medium"
//                           : "text-text-muted border-transparent hover:text-text-main dark:hover:text-white hover:border-text-muted"
//                       }`}
//                   >
//                     {item.label}
//                   </button>
//                 );
//               })}
//             </nav>
//           </div>
//         </div>

//         <div className="sticky bottom-32">
//           <div className="p-3 bg-gradient-to-br from-blue-50 to-white dark:from-blue-900/10 dark:to-surface-dark rounded-lg border border-blue-100 dark:border-blue-900/30">
//             <h4 className="flex items-center gap-2 font-semibold text-blue-900 dark:text-blue-200 text-xs mb-3">
//               <MdSupportAgent className="text-base" />
//               Enterprise Support
//             </h4>

//             <p className="text-[11px] text-blue-800 dark:text-blue-300 mb-3 leading-snug">
//               Stuck on deployment? Enterprise customers get 24/7 dedicated
//               support.
//             </p>

//             <button
//               onClick={() => setShowContact(true)}
//               className="w-full py-1.5 px-2 bg-white dark:bg-blue-600 text-blue-600 dark:text-white rounded-md text-[11px] font-semibold shadow-sm hover:shadow hover:bg-blue-50 dark:hover:bg-blue-500 transition-all border border-blue-100 dark:border-transparent"
//             >
//               Contact Engineer
//             </button>
//           </div>
//         </div>
//       </div>

//       {showContact &&
//         createPortal(
//           <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
//             <div className="bg-white dark:bg-slate-900 border border-blue-100 dark:border-slate-700 rounded-2xl shadow-2xl p-6 w-[320px] animate-fadeIn">
//               <div className="flex items-center justify-between mb-3">
//                 <h3 className="text-lg font-bold text-slate-900 dark:text-white">
//                   Contact Engineer
//                 </h3>
//                 <button
//                   onClick={() => setShowContact(false)}
//                   className="text-slate-400 hover:text-red-500 text-sm font-bold"
//                 >
//                   ✕
//                 </button>
//               </div>

//               <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 leading-relaxed">
//                 Need help? Reach out to our engineering team directly.
//               </p>

//               <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg p-3 text-center">
//                 <p className="text-xs text-slate-500 dark:text-slate-400 mb-1">
//                   Email
//                 </p>
//                 <p className="text-sm font-bold text-blue-600 dark:text-blue-400">
//                   admin@apmosys.com
//                 </p>
//               </div>

//               <div className="mt-5 flex gap-2">
//                 <button
//                   onClick={() => {
//                     navigator.clipboard.writeText("admin@apmosys.com");
//                     setCopied(true);
//                     setTimeout(() => setCopied(false), 2000);
//                   }}
//                   className={`flex-1 py-2 text-xs font-semibold rounded-lg transition
//                     ${
//                       copied
//                         ? "bg-green-600 text-white"
//                         : "bg-blue-600 text-white hover:bg-blue-700"
//                     }`}
//                 >
//                   {copied ? "Copied ✓" : "Copy Email"}
//                 </button>

//                 <button
//                   onClick={() => setShowContact(false)}
//                   className="flex-1 py-2 text-xs font-semibold rounded-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>,
//           document.body
//         )}
//     </aside>
//   );
// }
import { useMemo, useState, useRef, useEffect, useCallback } from "react";
import { tocMap } from "../../data/tocMap";
import { MdSupportAgent } from "react-icons/md";
import { FiInfo, FiChevronRight } from "react-icons/fi";
import { createPortal } from "react-dom";

export default function Toc({
  activeSection,
  focusMode,
  onToggleFocusMode,
  isCollapsed,
  onToggleCollapse,
}) {
  const [activeId, setActiveId] = useState(null);
  const tocScrollRef = useRef(null);
  const [showContact, setShowContact] = useState(false);
  const [copied, setCopied] = useState(false);
  const [readPercent, setReadPercent] = useState(0);

  const items = useMemo(() => {
    return tocMap?.[activeSection] || [];
  }, [activeSection]);

  const getScrollRoot = () => document.querySelector("main");

  const updateActiveId = useCallback(() => {
    if (!items.length) return;

    const scrollRoot = getScrollRoot();
    if (!scrollRoot) return;

    const rootRect = scrollRoot.getBoundingClientRect();
    const activationY = rootRect.top + 120;

    const atBottom =
      scrollRoot.scrollTop + scrollRoot.clientHeight >=
      scrollRoot.scrollHeight - 2;

    const positions = items
      .map((item) => {
        const el = document.getElementById(item.id);
        if (!el) return null;

        const rect = el.getBoundingClientRect();
        return {
          id: item.id,
          top: rect.top,
          bottom: rect.bottom,
        };
      })
      .filter(Boolean)
      .sort((a, b) => a.top - b.top);

    if (!positions.length) return;

    if (atBottom) {
      setActiveId(positions[positions.length - 1].id);
      return;
    }

    let currentId = positions[0].id;

    for (const pos of positions) {
      if (pos.top <= activationY) {
        currentId = pos.id;
      } else {
        break;
      }
    }

    setActiveId(currentId);
  }, [items]);

  // Reading progress (% scrolled through the main content area)
  const updateReadPercent = useCallback(() => {
    const scrollRoot = getScrollRoot();
    if (!scrollRoot) return;

    const scrollable = scrollRoot.scrollHeight - scrollRoot.clientHeight;
    const pct =
      scrollable <= 0
        ? 100
        : Math.min(
            100,
            Math.max(0, Math.round((scrollRoot.scrollTop / scrollable) * 100))
          );

    setReadPercent(pct);
  }, []);

  useEffect(() => {
    if (!items.length) return;

    const scrollRoot = getScrollRoot();
    if (!scrollRoot) return;

    let rafId = 0;

    const onScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        updateActiveId();
        updateReadPercent();
      });
    };

    scrollRoot.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    requestAnimationFrame(() => {
      updateActiveId();
      updateReadPercent();
    });

    return () => {
      cancelAnimationFrame(rafId);
      scrollRoot.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [items, activeSection, updateActiveId, updateReadPercent]);

  useEffect(() => {
    requestAnimationFrame(() => {
      if (tocScrollRef.current) {
        tocScrollRef.current.scrollTop = 0;
      }
    });

    if (items.length) {
      setActiveId(items[0].id);
    } else {
      setActiveId(null);
    }
  }, [activeSection, items]);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      setActiveId(id);
    }
  };

  if (!items.length) return null;

  // Collapsed state: small floating icon button with a tooltip
  if (isCollapsed) {
    return (
      <div className="hidden xl:block fixed top-20 right-4 z-40 group">
        <button
          onClick={() => onToggleCollapse?.()}
          aria-label="Open TOC"
          className="flex items-center justify-center w-9 h-9 rounded-full
            bg-gradient-to-br from-orange-500 to-red-500
            shadow-md text-white
            hover:brightness-110
            transition-all"
        >
          <FiInfo className="text-xl" />
        </button>

        <span
          className="pointer-events-none absolute right-full top-1/2 -translate-y-1/2 mr-2
            whitespace-nowrap rounded-md bg-gray-900 text-white text-xs px-2 py-1
            opacity-0 group-hover:opacity-100 transition-opacity"
        >
          Open TOC
        </span>
      </div>
    );
  }

  return (
    <aside
    data-toc
      className={`
        hidden xl:block
        fixed right-0
        top-16
        bottom-0
        w-72
        ${focusMode ? "" : "border-l border-gray-200 dark:border-gray-800"}
        bg-white dark:bg-[#0f0f0f] 
        text-sm text-gray-500
        z-40
      `}
    >
      <div className="flex flex-col h-full px-6 py-5">
        {/* Fixed header: title, focus mode, collapse, read % and progress bar */}
        <div className="flex-shrink-0">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-xs font-bold text-text-muted uppercase tracking-wider">
              On This Page
            </h3>

            <div className="flex items-center gap-2">
              <label className="flex items-center gap-1.5 cursor-pointer select-none">
                <span className="text-[11px] text-text-muted">Focus</span>
                <span
                  role="switch"
                  aria-checked={focusMode}
                  onClick={() => onToggleFocusMode?.()}
                  className={`relative inline-flex h-4 w-8 items-center rounded-full transition-colors
                    ${focusMode ? "bg-blue-600" : "bg-gray-300 dark:bg-gray-600"}`}
                >
                  <span
                    className={`inline-block h-3 w-3 transform rounded-full bg-white shadow transition-transform
                      ${focusMode ? "translate-x-4" : "translate-x-0.5"}`}
                  />
                </span>
              </label>

              <div className="relative group">
                <button
  onClick={() => onToggleCollapse?.()}
  aria-label="Collapse TOC"
  className="group flex items-center justify-center w-8 h-8 rounded-lg 
             text-gray-500 hover:text-orange-500 
             hover:bg-orange-50 dark:hover:bg-gray-800
             transition-all duration-200 ease-in-out"
>
  <FiChevronRight
    className="text-base transform transition-transform duration-300 group-hover:translate-x-0.5"
  />
</button>

                <span
                  className="pointer-events-none absolute top-full right-0 mt-2
                    whitespace-nowrap rounded-md bg-gray-900 text-white text-xs px-2 py-1
                    opacity-0 group-hover:opacity-100 transition-opacity z-50"
                >
                  Collapse
                </span>
              </div>
            </div>
          </div>

          <div className="flex justify-end mb-1">
            <span className="text-[10px] text-text-muted">
              {readPercent}% read
            </span>
          </div>

          <div className="w-full h-1 bg-gray-200 dark:bg-gray-700 rounded-full mb-4 overflow-hidden">
            <div
              className="h-full bg-blue-600 rounded-full transition-all duration-150"
              style={{ width: `${readPercent}%` }}
            />
          </div>
        </div>

        {/* Only this nav list scrolls */}
        <div
          ref={tocScrollRef}
          className="flex-1 overflow-y-auto hide-scrollbar"
        >
          <nav className="hide-scrollbar flex flex-col border-l border-gray-200 dark:border-gray-700">
            {items.map((item) => {
              const isActive = activeId === item.id;

              return (
                <button
                  key={item.id}
                  onClick={() => scrollToId(item.id)}
                  className={`block text-left pl-4 py-1 text-sm -ml-[1px] border-l-2 transition-all
                    ${
                      isActive
                        ? "text-blue-600 dark:text-blue-400 border-blue-500 font-medium"
                        : "text-text-muted border-transparent hover:text-text-main dark:hover:text-white hover:border-text-muted"
                    }`}
                >
                  {item.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Fixed footer: Enterprise Support box */}
        <div className="flex-shrink-0 mt-6">
          <div className="p-3 bg-gradient-to-br from-blue-50 to-white dark:from-blue-900/10 dark:to-surface-dark rounded-lg border border-blue-100 dark:border-blue-900/30">
            <h4 className="flex items-center gap-2 font-semibold text-blue-900 dark:text-blue-200 text-xs mb-3">
              <MdSupportAgent className="text-base" />
              Enterprise Support
            </h4>

            <p className="text-[11px] text-blue-800 dark:text-blue-300 mb-3 leading-snug">
              Stuck on deployment? Enterprise customers get 24/7 dedicated
              support.
            </p>

            <button
              onClick={() => setShowContact(true)}
              className="w-full py-1.5 px-2 bg-white dark:bg-blue-600 text-blue-600 dark:text-white rounded-md text-[11px] font-semibold shadow-sm hover:shadow hover:bg-blue-50 dark:hover:bg-blue-500 transition-all border border-blue-100 dark:border-transparent"
            >
              Contact Engineer
            </button>
          </div>
        </div>
      </div>

      {showContact &&
        createPortal(
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            <div className="bg-white dark:bg-slate-900 border border-blue-100 dark:border-slate-700 rounded-2xl shadow-2xl p-6 w-[320px] animate-fadeIn">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-lg font-bold text-slate-900 dark:text-white">
                  Contact Engineer
                </h3>
                <button
                  onClick={() => setShowContact(false)}
                  className="text-slate-400 hover:text-red-500 text-sm font-bold"
                >
                  ✕
                </button>
              </div>

              <p className="text-sm text-slate-600 dark:text-slate-400 mb-4 leading-relaxed">
                Need help? Reach out to our engineering team directly.
              </p>

              <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg p-3 text-center">
                <p className="text-xs text-slate-500 dark:text-slate-400 mb-1">
                  Email
                </p>
                <p className="text-sm font-bold text-blue-600 dark:text-blue-400">
                  admin@apmosys.com
                </p>
              </div>

              <div className="mt-5 flex gap-2">
                <button
                  onClick={() => {
                    navigator.clipboard.writeText("admin@apmosys.com");
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2000);
                  }}
                  className={`flex-1 py-2 text-xs font-semibold rounded-lg transition
                    ${
                      copied
                        ? "bg-green-600 text-white"
                        : "bg-blue-600 text-white hover:bg-blue-700"
                    }`}
                >
                  {copied ? "Copied ✓" : "Copy Email"}
                </button>

                <button
                  onClick={() => setShowContact(false)}
                  className="flex-1 py-2 text-xs font-semibold rounded-lg border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition"
                >
                  Close
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </aside>
  );
}